import { BoardType } from "@sportactics/board-editing";
import useSWR from "swr";

import { getSWRKey, SwrStore } from "~utils";

import { useFirebaseAuth } from "../user";
import { useBoardTypeFirestorePersistence } from "./use-board-type-firestore-persistence";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useBoardTypeFirestoreSWR() {
  const key = useKey();
  const fetcher = useFetcher();

  return useSWR(key, fetcher, { suspense: true });
}

export function getBoardTypeFirestoreSWRKey(
  userId: string,
): BoardTypeFirestoreSWRKey {
  return getSWRKey(SwrStore.FirestoreBoardType, userId);
}

export type BoardTypeFirestoreSWRKey = readonly [SwrStore, string];

// Anonymous users get no key at all, so no document is ever read or written for the
// throwaway identity every first-time visitor is given.
function useKey(): BoardTypeFirestoreSWRKey | null {
  const { userId, authenticated } = useFirebaseAuth();

  if (!authenticated) return null;
  return getBoardTypeFirestoreSWRKey(userId);
}

function useFetcher(): (
  key: BoardTypeFirestoreSWRKey,
) => Promise<BoardType | null> {
  const { getBoardType } = useBoardTypeFirestorePersistence();

  return async ([, userId]) => (await getBoardType(userId)) ?? null;
}
